import Axios from 'axios'

import type {
  TCreateDerivedMetricRequest,
  TCreateDerivedMetricResponse,
  TDerivedMetricDto,
  TDerivedMetricOptionsDto,
  TDerivedMetricPreviewRequest,
  TDerivedMetricPreviewResponse,
  TUpdateDerivedMetricRequest,
  TUpdateDerivedMetricResponse
} from '@homepal/api-contract'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/internal/derived-metrics`

export async function getAll() {
  return getWithRedirect<TDerivedMetricDto[]>(URL, parseAuthenticationHeader())
}

export async function getOptions() {
  return getWithRedirect<TDerivedMetricOptionsDto>(
    `${URL}/options`,
    parseAuthenticationHeader()
  )
}

export async function preview(body: TDerivedMetricPreviewRequest) {
  return Axios.post<TDerivedMetricPreviewResponse>(
    `${URL}/preview`,
    body,
    parseAuthenticationHeader()
  )
}

export async function create(body: TCreateDerivedMetricRequest) {
  return Axios.post<TCreateDerivedMetricResponse>(
    URL,
    body,
    parseAuthenticationHeader()
  )
}

export async function update(id: string, body: TUpdateDerivedMetricRequest) {
  return Axios.patch<TUpdateDerivedMetricResponse>(
    `${URL}/${id}`,
    body,
    parseAuthenticationHeader()
  )
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, parseAuthenticationHeader())
}
